import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '../services/analytics';

/**
 * Hook to automatically track page views on route changes
 */
export const usePageTracking = () => {
  const location = useLocation();
  const lastPathname = useRef<string>('');
  const entryTime = useRef<number>(Date.now());

  useEffect(() => {
    // Track previous page duration before switching
    if (lastPathname.current && location.pathname !== lastPathname.current) {
      const duration = Math.round((Date.now() - entryTime.current) / 1000);
      if (duration > 0) {
        analytics.trackSessionTime(lastPathname.current, duration);
      }
    }

    // Only track if the pathname has actually changed
    if (location.pathname !== lastPathname.current) {
      const pageTitle = document.title || 'CanvasEstate Dashboard';
      analytics.trackPageView(location.pathname, pageTitle);
      
      lastPathname.current = location.pathname;
      entryTime.current = Date.now();
    }

    // Cleanup: track duration on final unmount
    return () => {
      if (lastPathname.current) {
        const duration = Math.round((Date.now() - entryTime.current) / 1000);
        if (duration > 0) {
          analytics.trackSessionTime(lastPathname.current, duration);
        }
      }
    };
  }, [location]);
};
